export const MAX_TEXT_LENGTH = 5000;
export const MAX_TOTAL_FILE_SIZE = 20 * 1024 * 1024; // 20 MB
export const MAX_SINGLE_FILE_SIZE = 50 * 1024 * 1024; // 50 MB (backend limit)

// Accept attribute for file inputs — matches backend allowed types
export const FILE_ACCEPT = [
  "image/*",
  "video/*",
  "audio/*",
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".txt",
  ".csv",
  ".html",
  ".md",
  ".rtf",
  ".json",
  ".xml",
  ".zip",
  ".rar",
  ".7z",
  ".tar",
  ".gz",
].join(",");

// Extensions for client-side validation (lowercase, no dot)
const ALLOWED_EXTENSIONS = new Set([
  // Images
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "tiff",
  "tif",
  "heic",
  "heif",
  "avif",
  // Video
  "mp4",
  "mov",
  "avi",
  "mkv",
  "webm",
  "mpeg",
  "mpg",
  "3gp",
  "3g2",
  "flv",
  // Audio
  "mp3",
  "wav",
  "aac",
  "ogg",
  "flac",
  "m4a",
  // Documents
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "csv",
  "html",
  "md",
  "rtf",
  "xml",
  // Archives
  "zip",
  "rar",
  "7z",
  "tar",
  "gz",
]);

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const isAllowedFileType = (file: File): boolean => {
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  return ALLOWED_EXTENSIONS.has(ext);
};

export const UPLOAD_HINT = "Images, videos, audio, documents, or archives \u00b7 50 MB per file";

/** Filter files into [accepted, rejected] based on extension + size. */
export const validateFiles = (
  files: File[],
): { accepted: File[]; rejected: string[] } => {
  const accepted: File[] = [];
  const rejected: string[] = [];
  for (const f of files) {
    if (!isAllowedFileType(f)) {
      rejected.push(`${f.name} (unsupported type)`);
    } else if (f.size > MAX_SINGLE_FILE_SIZE) {
      rejected.push(`${f.name} (exceeds 50 MB)`);
    } else {
      accepted.push(f);
    }
  }
  return { accepted, rejected };
};
